import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { SeoSlugListTable } from "@/components/seo-slug/table";
import { useGetAllSeoSlugs } from "@/hooks/api/seo-slug/useGetAllSeoSlugs";
import { AppPage } from "@/layouts/page";

export function SeoSlugsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(20);

  const page = Math.max(1, parseInt(searchParams.get("page") ?? "1") || 1);

  const { data: seoSlugs, isFetching } = useGetAllSeoSlugs({
    searchTerm,
    page,
    limit,
  });

  const changePage = (next: number) => {
    const params = new URLSearchParams(searchParams);

    params.set("page", next.toString());
    setSearchParams(params);
  };

  // A new search or page size starts again from page one.
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      return;
    }
    if (page !== 1) changePage(1);
  }, [searchTerm, limit]);

  const total = seoSlugs?.total;

  return (
    <AppPage
      subtitle={
        total === undefined
          ? undefined
          : `${total.toLocaleString()} slugs and their meta content`
      }
      title="SEO Slugs"
    >
      <SeoSlugListTable
        changePage={changePage}
        isLoading={isFetching && !seoSlugs}
        items={seoSlugs?.data ?? []}
        limit={limit}
        page={page}
        searchTerm={searchTerm}
        totalItems={total ?? 0}
        onLimitChange={setLimit}
        onSearchChange={setSearchTerm}
      />
    </AppPage>
  );
}
